import React from "react";
import "./App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

// Auth Pages
import Login from "./pages/auth/Login";
import Register from "./pages/auth/Register";
import ForgotPassword from "./pages/auth/ForgotPassword";
import ResetPassword from "./pages/auth/ResetPassword";

// Dashboard and Components
import DashBoard from "./components/Dashboard/DashBoard";
import Logout from "./pages/auth/Logout";
import Location from "./components/Location/Location";
import Profile from "./components/Profile/Profile";
import Company from "./components/Company/Company";
import Vessel from "./components/Vessel/Vessel";
import Invoice from "./components/Invoice/Invoice";
import Report from "./components/Report/Report";
import DashboardList from "./components/Dashboard/DashboardlList";
import ProfileDropdown from "./components/Profile/ProfileDropdown";
import Demo from "./components/Report/Demo";
import NotFoundPage from "./components/NotFoundPage";
import User from "./components/User/User";
import Employee from "./components/Employee/Employee";
import Loan from "./components/Loan/Loan";
import LoanTable from "./components/Loan/LoanTable";
import Logistics from "./components/Logistics/Logistics";
import FoodAllowance from "./components/FoodAllowance/FoodAllowance";
import StockList from "./components/Logistics/StockList";
import PurchaseList from "./components/Logistics/PurchaseList";
import StockOutList from "./components/Logistics/StockOutList";
import StockReport from "./components/Logistics/StockReport";
import PurchaseReport from "./components/Logistics/PurchaseReport";
import TransferList from "./components/Logistics/TransferList";
import StockOutConsolidatedReport from "./components/Logistics/StockOutConsolidatedReport";
import PurchaseConsolidatedReport from "./components/Logistics/PurchaseConsolidatedReport";
import LogisticsEmployeeList from "./components/Logistics/LogisticsEmployeeList";

// Protected Route Component
const ProtectedRoute = ({ children }) => {
  const isAuthenticated =
    sessionStorage.getItem("authToken") || localStorage.getItem("authToken");

  if (!isAuthenticated) {
    // Redirect to login if not authenticated
    return <Navigate to="/" />;
  }

  return children;
};

function App() {
  return (
    <div className="App">
      <BrowserRouter
        future={{ v7_startTransition: true, v7_relativeSplatPath: true }}
      >
        <ToastContainer />
        <Routes>
          {/* Public Routes */}
          <Route path="/" element={<Login />} />
          <Route path="/register" element={<Register />} />
          <Route path="/logout" element={<Logout />} />
          <Route path="/forgot" element={<ForgotPassword />} />
          <Route path="/reset-password/:token" element={<ResetPassword />} />
          <Route path="/drop" element={<ProfileDropdown />} />

          {/* Protected Routes */}
          <Route
            path="/"
            element={
              <ProtectedRoute>
                <DashBoard />
              </ProtectedRoute>
            }
          >
            {/* Nested routes for Dashboard */}
            <Route path="company" element={<Company />} />
            <Route path="location" element={<Location />} />
            <Route path="user" element={<User />} />
            <Route path="vessel" element={<Vessel />} />
            <Route path="invoice" element={<Invoice />} />
            <Route path="profile" element={<Profile />} />
            <Route path="report" element={<Report />} />
            <Route path="home" element={<DashboardList />} />
            <Route path="demo" element={<Demo />} />
            <Route path="employee" element={<Employee />} />
            <Route path="loan" element={<Loan />} />
            <Route path="loan/loantable" element={<LoanTable />} />
            <Route path="logistics" element={<StockList />} />
            <Route path="foodallowance" element={<FoodAllowance />} />
            <Route path="logistics/employeelist" element={<LogisticsEmployeeList />} />
            <Route path="logistics/stocklist" element={<StockList />} />
            <Route path="logistics/stocktransfer" element={<TransferList />} />
            <Route path="stock/report" element={<StockReport />} />
            <Route path="logistics/purchaselist" element={<PurchaseList />} />
            <Route
              path="logistics/purchase-report"
              element={<PurchaseReport />}
            />
            <Route path="logistics/stockoutlist" element={<StockOutList />} />
            <Route
              path="logistics/stockout-consolidated"
              element={<StockOutConsolidatedReport />}
            />
            <Route
              path="logistics/purchase-consolidated"
              element={<PurchaseConsolidatedReport />}
            />
          </Route>

          {/* Fallback Route for 404 */}
          <Route path="*" element={<NotFoundPage />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
